import { ComponentsOverrides, Theme } from "@mui/material";
import { CSSObject } from "@mui/system";

import borders from "@/themes/base/borders";
import colors from "@/themes/base/colors";
import pxToRem from "@/themes/functions/pxToRem";

const { borderWidth } = borders;
const { light } = colors;

interface ITableCell {
  styleOverrides: ComponentsOverrides<Theme>["MuiTableCell"];
}

const tableCell: ITableCell = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(12)} ${pxToRem(16)}`,
      borderBottom: `${borderWidth[1]} solid ${light.main}`,
    } as CSSObject,
  },
};

export default tableCell;
